import deleteActionApi from './deleteActionApi';
import getActionsApi from './getActionsApi';
import getActionsErrorsApi from './getActionsErrorsApi';
import getActionsTrashApi from './getActionsTrashApi';
import getSchedulesIdsWithAction from './getSchedulesIdsWithAction';
import getTemplateListApi from './getTemplateListApi';
import saveActionApi from './saveActionApi';

export default {
  deleteActionApi,
  getActionsApi,
  getActionsErrorsApi,
  getActionsTrashApi,
  getSchedulesIdsWithAction,
  getTemplateListApi,
  saveActionApi,
};
